import { ValgStateActionTypes, TOGGLE_VILKAR, ToggleVilkarAction, ValgState, UPDATE_VALG } from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederBarnestipendAppState } from '..';
import { AnyAction } from 'redux';
import { setVisning } from '../Resultat/Actions';
import BFamiliesituasjon from '../../Utilities/B-Familiesituasjon';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export function toggleVilkar(): ToggleVilkarAction {
    return {
        type: TOGGLE_VILKAR,
    };
}

const getB = (state: VeilederBarnestipendAppState): string | undefined => {
    return state.valg.bFamiliesituasjon?.value;
};

const visC1 = (state: VeilederBarnestipendAppState): boolean => {
    return getB(state) === BFamiliesituasjon.b1ToForeldre;
};

const visC2 = (state: VeilederBarnestipendAppState): boolean => {
    return getB(state) === BFamiliesituasjon.b2Alene;
};

export const updateVisning = (): ThunkAction<void, VeilederBarnestipendAppState, {}, AnyAction> => {
    return (
        dispatch: ThunkDispatch<VeilederBarnestipendAppState, {}, AnyAction>,
        getState: () => VeilederBarnestipendAppState,
    ): void => {
        const currentState = getState();
        const visResultatC1 = visC1(currentState);
        const visResultatC2 = visC2(currentState);

        dispatch(setVisning({ visResultatC1, visResultatC2 }));
    };
};
